export default __webpack_public_path__ + "a6765c78842fa00f7b19953a0de59abc.svg";